<div class="field-value">
  @if (label) {
    <label
      [for]="idName + '_input'"
      class="input-label-value {{ labelClass }}"
      [ngClass]="{ required: isRequired() }">
      {{ label | cxTranslate }}
      @if (labelTooltip ? (labelTooltip | cxTranslate) : false) {
        <span
          class="aimo-icon icon-inline icon-info icon-sm"
          placement="top"
          ngbTooltip="{{ labelTooltip | cxTranslate }}"
        role="button"></span>
      }
    </label>
  }
  @if (parentForm) {
    <div
      [formGroup]="parentForm"
      [class.is-invalid]="isNotValidFunction ? isNotValidFunction : isNotValid(nameForm)"
      [ngClass]="hasValue() ? 'has-value' : ''">
      <ng-select
        #selectElement
        [id]="idName"
        [labelForId]="idName + '_input'"
        (change)="onChange($event)"
        [bindLabel]="bindLabel"
        [bindValue]="bindValue"
        [class]="cssClass"
        [clearable]="clearable"
        [closeOnSelect]="true"
        [formControlName]="nameForm"
        [items]="items"
        [multiple]="false"
        [placeholder]="placeholder ? (placeholder | cxTranslate) : ''"
        [searchable]="false"
        [notFoundText]="'aimo.select.noItemsFound' | cxTranslate">
        @if (showTemplateIcon; as item) {
          <ng-template ng-option-tmp let-item="item">
            @if (item.visibility) {
              <i
                class="aimo-icon icon-sm icon-petrol-blue icon-inline mr-2"
                        [ngClass]="{
                            'icon-user': item.visibility === 'private',
                            'icon-users': item.visibility === 'public',
                            'icon-house-line': item.visibility === 'central',
                        }">
              </i>
            }
            <span [ngClass]="{ 'text-bold': item.code === 'new_template' }">{{ item.name }}</span>
          </ng-template>
        }
        @if (showTemplateIcon; as item) {
          <ng-template ng-label-tmp let-item="item">
            @if (item.visibility) {
              <i
                class="aimo-icon icon-sm icon-petrol-blue icon-inline mr-2"
                        [ngClass]="{
                            'icon-user': item.visibility === 'private',
                            'icon-users': item.visibility === 'public',
                            'icon-house-line': item.visibility === 'central',
                        }">
              </i>
            }
            <span>{{ item.name }}</span>
          </ng-template>
        }
        @if (savedFilters; as item) {
          <ng-template ng-option-tmp let-item="item">
            <div class="saved-facet-item">
              {{ item.name }}
              <i (click)="onClick($event, item)" class="aimo-icon icon-inline icon-sm icon-trash"></i>
            </div>
          </ng-template>
        }
        @if (translateByCode; as item) {
          <ng-template ng-option-tmp let-item="item">
            {{ 'aimo.select.' + nameForm + '.' + item[bindValue] | cxTranslate }}
          </ng-template>
        }
        @if (translateByCode; as item) {
          <ng-template ng-label-tmp let-item="item">
            {{ 'aimo.select.' + nameForm + '.' + item[bindValue] | cxTranslate }}
          </ng-template>
        }
      </ng-select>
    </div>
  }

  @if (!parentForm) {
    <ng-select
      #selectElement
      [id]="idName"
      [labelForId]="idName + '_input'"
      (change)="onChange($event)"
      [bindLabel]="bindLabel"
      [bindValue]="bindValue"
      [class]="cssClass"
      [clearable]="clearable"
      [notFoundText]="'aimo.select.noItemsFound' | cxTranslate"
      [closeOnSelect]="true"
      [items]="items"
      [multiple]="false"
      [ngModel]="selectedValue"
      [placeholder]="placeholder ? (placeholder | cxTranslate) : ''"
      [searchable]="false">
      @if (savedFilters; as item) {
        <ng-template ng-option-tmp let-item="item">
          <div class="saved-facet-item">
            {{ item.name }}
            <i (click)="onClick($event, item)" class="aimo-icon icon-inline icon-sm icon-trash"></i>
          </div>
        </ng-template>
      }
      @if (translateByCode; as item) {
        <ng-template ng-option-tmp let-item="item">
          {{ 'aimo.select.' + nameForm + '.' + item[bindValue] | cxTranslate }}
        </ng-template>
      }
      @if (translateByCode; as item) {
        <ng-template ng-label-tmp let-item="item">
          {{ 'aimo.select.' + nameForm + '.' + item[bindValue] | cxTranslate }}
        </ng-template>
      }
    </ng-select>
  }
</div>

@if ((isNotValidFunction ? isNotValidFunction : isNotValid(nameForm)) && errorMessage) {
  <div
    class="invalid-feedback d-block text-right"
    >
    <span>{{ errorMessage | cxTranslate }}</span>
  </div>
}
@if (extraInfoBottom) {
  <div class="extra-info text-right">
    {{ extraInfoBottom | cxTranslate }}
  </div>
}
